import { shortId } from './ids.js';
import { tick, receive } from '../sync/hlc.js';

export async function getMeta(db, key, fallback = null) {
  const row = await db.meta.get(key);
  return row ? row.value : fallback;
}

export function setMeta(db, key, value) {
  return db.meta.put({ key, value });
}

export async function getDeviceId(db) {
  return db.transaction('rw', db.meta, async () => {
    let id = await getMeta(db, 'deviceId');
    if (!id) {
      id = shortId();
      await setMeta(db, 'deviceId', id);
    }
    return id;
  });
}

/**
 * Next HLC timestamp. Reads and writes the persisted clock inside the caller's
 * transaction so concurrent tabs on the same device stay strictly monotonic.
 */
export async function nextHlc(db, now = Date.now()) {
  const node = await getDeviceId(db);
  const state = await getMeta(db, 'clock', { ms: 0, counter: 0 });
  const { state: next, hlc } = tick(state, node, now);
  await setMeta(db, 'clock', next);
  return hlc;
}

export async function observeHlc(db, remoteHlc) {
  const state = await getMeta(db, 'clock', { ms: 0, counter: 0 });
  await setMeta(db, 'clock', receive(state, remoteHlc));
}
